
import { Component, Vue, Prop } from 'vue-property-decorator';
import { FieldObject } from '~/interfaces/field.interface';
import DeviceData from '~/components/Data.vue';
import Users from '~/components/Eliot/Users.vue';

@Component({
    components: {
        DeviceData,
        Users,
    },
})
export default class EliotDevice extends Vue {
    @Prop() title!: string;
    @Prop() deviceData!: FieldObject[][];
    @Prop() networkData!: FieldObject[][];
    @Prop() allowedUsers!: Array<{ id: string, email: string }>;
    @Prop() invitedUsers!: Array<{ id: string, email: string }>;
}
